import { useMutation } from "@tanstack/react-query";
import axios from "axios";

import client from "./client";
import { DeviceSearchRequest, EquipmentInfoRequest, EquipSearchRequest, PartRequest, PlanImagePositionRequest, PlanImageRequest, PlanPositionRequest, SectionRequest, ZoneRequest } from "./DeviceRequest";
import { BaseResp, ChangedEquipListResp, DeviceListResp, FactoryCodeListResp, FactoryListResp } from "./response";

type QrVersionReq = {
  factoryId: string;
  equipIdList: number[];
}

export const getPartList = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('v1/admin/part', { params: req });
export const getZoneList = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('/v1/admin/zone', { params: req });
export const getZoneListByFactory = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('/v1/admin/zone/factory', { params: req });
export const getSectionList = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('/v1/admin/section', { params: req });
export const getSectionListByFactory = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('/v1/admin/section/factory', { params: req });

export const getEquipList = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('/v1/equip/list', { params: req });
export const getEquipAllList = (req: DeviceSearchRequest | EquipSearchRequest): Promise<DeviceListResp> => client.get('/v1/equip/list', { params: req });
const registerEquip = (req: EquipmentInfoRequest): Promise<BaseResp> => client.post('/v1/equip', { ...req });
export const useRegisterEquipMutation = () => useMutation(registerEquip);
const editEquip = (req: EquipmentInfoRequest): Promise<BaseResp> => client.post(`/v1/equip/${req.id}/modify`, { ...req });
export const useEditEquipMutation = () => useMutation(editEquip);


const registerDevice = (req: PartRequest | ZoneRequest | SectionRequest): Promise<BaseResp> => client.post(`/v1/admin/${req.type}`, { ...req });
export const useRegisterDeviceMutation = () => useMutation(registerDevice);
const editDevice = (req: PartRequest | ZoneRequest | SectionRequest): Promise<BaseResp> => client.post(`/v1/admin/${req.type}/${req.id}`, { ...req });
export const useEditDeviceMutation = () => useMutation(editDevice);

const registerPlanImage = (req: PlanImageRequest) =>
  axios.postForm(
    `/v1/admin/${req.type.toUpperCase()}/${req.typeId}/image`,
    { ...req, image: req.image[0] },
    { baseURL: `${process.env.REACT_APP_BASE_URL}/api`, withCredentials: true }
  );
export const useRegisterPlanImageMutation = () => useMutation(registerPlanImage);

const registerRectPosition = (req: PlanPositionRequest): Promise<BaseResp> => client.post(`/v1/admin/${req.type}/${req.typeId}/position`, { ...req });
export const useRegisterRectPosition = () => useMutation(registerRectPosition);

const registerImageRectPosition = (req: PlanImagePositionRequest[]): Promise<BaseResp> => client.post(`/v1/equip/position`, { body: JSON.stringify(req) });
export const useRegisterImageRectMutation = () => useMutation(registerImageRectPosition);


export const getFactoryList = (local?: string): Promise<FactoryListResp> => client.get('v1/admin/factory', { params: { localId: local } });

export const getFactoryCodeList = (localId: string): Promise<FactoryCodeListResp> => client.get('v1/admin/factory/code', { params: localId });

export const getChangedEquipListByQr = (req: QrVersionReq): Promise<ChangedEquipListResp> => client.get('v1/equip/print/qr', { params: { equipIds: req.equipIdList.toString(), factoryId: req.factoryId } });

const updateQrVersion = (req: QrVersionReq): Promise<BaseResp> => client.post('/v1/equip/version/update', { equipIds: req.equipIdList.toString(), factoryId: req.factoryId });
export const useUpdateQrVersionMutate = () => useMutation(updateQrVersion);
